<script>
import { dateFormatReadable } from "@/utils";
export default {
  name: "ore-recommendations",
  props: ["item", "start_date", "end_date"],
  data() {
    return {
      show: false
    };
  },
  computed: {
    start() {
      return dateFormatReadable(
        this.item && this.item.start ? this.item.start : this.start_date
      );
    },
    end() {
      return dateFormatReadable(
        this.item && this.item.end ? this.item.end : this.end_date
      );
    }
  }
};
</script>

<template>
  <div class="d-flex align-items-center justify-content-center">
    <div class="mr-5">
      <div class="d-flex align-items-center justify-content-center">
        <h5>RECOMMENDATIONS</h5>
      </div>
    </div>
    <div>
      <h5 style="text-transform: uppercase;">{{ start }} to {{ end }}</h5>
    </div>
  </div>
</template>
